import { connect } from 'react-redux'
import AdventuresSlider from './AdventuresSlider'
import Proptypes from 'prop-types'

function OtherAdventures({ activityId, selectedCurrency }) {
  return <AdventuresSlider activityId={activityId} selectedCurrency={selectedCurrency} />
}

export default connect((state) => ({
  selectedCurrency: state.selectedCurrency,
}))(OtherAdventures)

OtherAdventures.propTypes = {
  selectedCurrency: Proptypes.string,
  activityId: Proptypes.oneOfType([Proptypes.string, Proptypes.number]),
}
